import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {MultiSelect, Option} from 'react-multi-select-component'
import {useCities} from '../../../../../hooks/useCities'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const SelectCities = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const regions = jbp?.regions?.map((region) => region.id).join(',') ?? ''
  const {options, isLoading} = useCities(regions ?? '')

  const handleChange = (values: Option[]) => {
    const cities = values.map((item) => ({id: item.value, city_name: item.label}))
    dispatch(setJbpDetail({...jbp, cities}))
  }

  const value = !jbp?.cities
    ? []
    : jbp?.cities.map((city) => ({label: city.city_name ?? '', value: city.id ?? ''}))

  if (isLoading || (jbp && jbp?.regions && jbp?.regions?.length <= 0)) return <></>

  return (
    <Form.Group controlId='select-cities'>
      <Form.Label>{t('sub-order-kota')}</Form.Label>
      <MultiSelect
        options={options}
        value={value}
        onChange={(values: Option[]) => handleChange(values)}
        labelledBy='Select'
      />
    </Form.Group>
  )
}
